import { createFileRoute, redirect } from "@tanstack/react-router";
import { queryClient } from "../lib/queryClient";
import { meQuery, type Me } from "../hooks/useAuth";
import { RolesPanel } from "../components/settings/roles/RolesPanel";

export const Route = createFileRoute("/_auth/settings/roles")({
  staticData: {
    titleKey: "settings.roles.title",
    breadcrumbKey: "breadcrumb.manage",
    breadcrumbN: 2,
  },
  beforeLoad: () => {
    const me = queryClient.getQueryData<Me>(meQuery.queryKey);
    if (me && !me.permissions?.includes("manage_roles")) {
      throw redirect({ to: "/settings/pos-sync" });
    }
  },
  component: RolesPanel,
});
